// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tag.is-clickable[data-v-6347b39d] {\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n.tag.is-clickable[data-v-6347b39d]:hover {\n  opacity: 0.8;\n}\n.tag[data-v-6347b39d] {\n  border-radius: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
